/**
 * @deprecated Do not use legacy components anymore.
 */
export var Z_INDEX = {
    DRAWER: 1200,
    MODAL: 1300,
    MENU_PORTAL: 99999,
    TOOLTIP: 100001,
    TOAST: 999999,
    NOTIFICATION: 999999,
    COVER_BLOCK: 9999999999,
};
Object.freeze(Z_INDEX);
//# sourceMappingURL=zIndexConstants.js.map